import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  goalmouth: require("../../../assets/wc/images/goalmouth_transparent.png"),
  goalmouth_field: require("../../../assets/wc/images/goalmouth_field_transparent.png"),
};

export default assets;
